import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import {
  Box,
  CardActionArea,
  Chip,
  Grid2,
  Modal,
  Skeleton,
  Typography,
} from '@mui/material';
import { IEventSimpleProps } from 'services/Events/types';
import LprEventList from 'pages/MonitoringPage/_components/LprEventList';
import IvsEventList from 'pages/MonitoringPage/_components/IvsEventList';
import FaceEventsListPage from 'pages/RecognitionPages/Events';
import DefenseEventsPage from 'pages/DefensePages/Events';
import { t } from 'i18next';
import {
  useFirebaseImageFromUrl,
  useFirebaseImageMutateFromUrl,
} from '../../../firebase';

interface CardLastEventProps {
  title: string;
  event: IEventSimpleProps;
  widthProps: string;
  iconProp?: React.ReactElement;
  nameEvent: string;
}

interface IEventDetailsList {
  label: string;
  value: any;
}

const CardLastEvent = ({
  title,
  event,
  widthProps,
  iconProp,
  nameEvent,
}: CardLastEventProps) => {
  const [imageToRender, setImageToRender] = useState<string>();
  const [eventDetails, setEventDetails] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const { mutate: loadImage, isLoading: isLoadingImage } =
    useFirebaseImageMutateFromUrl();
  useEffect(() => {
    if (!event) return;

    let publicUrl = '';

    if (event.carImage?.includes('https')) {
      publicUrl = event.carImage;
    } else if (event.recognitionImage?.includes('https')) {
      publicUrl = event.recognitionImage;
    } else if (event.image?.includes('https')) {
      publicUrl = event.image;
    }

    if (!publicUrl) return;

    loadImage(publicUrl, {
      onSuccess: (tempUrl) => {
        setImageToRender(tempUrl ?? undefined);
      },
      onError: (err) => {
        console.error('Erro ao resolver imagem do evento', err);
        setImageToRender(undefined);
      },
    });
  }, [event]);
  useEffect(() => {
    if (event) {
      setEventDetails(event);
    }
  }, [event]);

  const getValuesToRenderByEventType = (): any[] => {
    const details: IEventDetailsList[] = [];
    if (event && event?.id && eventDetails) {
      for (const prop in eventDetails) {
        if (eventDetails[prop]) {
          if (prop === 'description') {
            details.push({
              label: t('common.description'),
              value: eventDetails[prop],
            });
          }
        }
      }

      switch (event.discriminator) {
        case 'FaceRecognitionEventEntity':
          details.push({
            label: t('common.date'),
            value: eventDetails.createdAt,
          });
          break;
        case 'LprEventEntity':
          details.push({
            label: t('common.date'),
            value: eventDetails.createdAt,
          });
          break;
        case 'IvsEventEntity':
          details.push({
            label: t('common.date'),
            value: eventDetails.createdAt,
          });
          break;
        case 'StudentRecognitionEventEntity':
        case 'ResponsibleRecognitionEventEntity':
          details.push({
            label: t('common.date'),
            value: eventDetails.createdAt,
          });
          break;
      }
    }
    return details;
  };

  const renderEventDetails = () => {
    const valuesToRender: IEventDetailsList[] = getValuesToRenderByEventType();

    return valuesToRender.map((item, index) => (
      <Box key={index}>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-start'}
          justifyContent={'start'}
        >
          <Box>
            <Typography sx={{ fontWeight: 'bold', color: '#4967a6' }}>
              {item.label}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={'13px'}>{item.value}</Typography>
          </Box>
        </Box>
      </Box>
    ));
  };

  return (
    <CardActionArea>
      <>
        <Card
          onClick={handleOpenModal}
          sx={{
            width: '100%',
            height: '47vh',
            p: 2,
            backgroundColor: '#202940',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            borderRadius: 4,
            boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
          }}
        >
          <Grid2
            width={'90%'}
            position={'absolute'}
            display={'flex'}
            justifyContent={'end'}
            top={10}
            right={10}
          >
            <Box>
              <Chip icon={iconProp} color="primary" label={title} />
            </Box>
          </Grid2>
          <Grid2
            sx={{
              display: 'flex',
              flexDirection: 'column-reverse',
              justifyContent: 'start',
              alignItems: 'center',
              height: '100%',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {!event ? (
              <Typography color="text.secondary" sx={{ mt: 2 }}>
                {t('dontHaveEvents')}
              </Typography>
            ) : imageToRender && imageToRender.indexOf('https') > -1 ? (
              <img
                src={imageToRender}
                alt="Imagem do Evento"
                style={{
                  width: widthProps,
                  maxHeight: '25vh',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
              />
            ) : (
              <Skeleton variant="rounded" width={widthProps} height={'25vh'} />
            )}
          </Grid2>
          <Grid2
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              margin: 2,
              padding: 1,
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Box
              display={'flex'}
              flexDirection={'column'}
              alignItems={'left'}
              textAlign={'left'}
              width={'100%'}
            >
              {renderEventDetails()}
            </Box>
          </Grid2>
        </Card>
        <Modal
          open={isModalOpen}
          onClose={handleCloseModal}
          sx={{
            border: 'null',
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
          }}
        >
          <Box
            sx={{
              maxHeight: '90vh',
              maxWidth: '180vh',
              bgcolor: '#202940',
              borderRadius: 4,
              boxShadow: 24,
              p: 2,
              position: 'relative',
              overflowY: 'auto',
            }}
          >
            {event?.discriminator === 'LprEventEntity' && <LprEventList />}
            {event?.discriminator === 'IvsEventEntity' && <IvsEventList />}
            {(event?.discriminator === 'FaceRecognitionEventEntity' ||
              event?.discriminator === 'StudentRecognitionEventEntity' ||
              event?.discriminator === 'ResponsibleRecognitionEventEntity') && (
              <FaceEventsListPage />
            )}
            {event?.discriminator === 'DefenseEventEntity' && (
              <DefenseEventsPage />
            )}
          </Box>
        </Modal>
      </>
    </CardActionArea>
  );
};

export default CardLastEvent;
